import { ISettings } from '../types';

function prepareSettingsDefaults(settings: ISettings): void {
  // NOTE: https://jira.wixpress.com/browse/POD-260
  settings.colors.episode.playerControlsColor =
    settings.colors.episode.playerControlsColor ||
    settings.colors.episode.headerTitleColor;
}

export default prepareSettingsDefaults;
